import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import RegisterTips from "../components/RegisterTips";
import RegisterForm from "../components/RegisterForm";
import * as actions from "../redux/actions/sessionActions";
import { isPasswordStrong } from "../utils/passwordValidation";

const INITIAL_ERRORS = {
  email: false,
  password: false,
  password2: false,
  country_id: false,
};

class Register extends React.Component {
  state = {
    form: {},
    accept_tos: false,
    error: { ...INITIAL_ERRORS },
    passwordErrorKey: "",
    password2ErrorKey: "",
  };

  validateEmail = (email) => {
    const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    return !reg.test(email);
  };

  getPasswordErrorKey = (password) => {
    if (!password) {
      return "warning_password";
    }
    if (!isPasswordStrong(password)) {
      return "warning_password_weak";
    }
    return "";
  };

  onChangeForm = (e) => {
    const { name, value } = e.target;

    this.setState((prev) => {
      const nextForm = { ...prev.form, [name]: value };
      const nextState = {
        form: nextForm,
        error: { ...prev.error, [name]: false },
        passwordErrorKey: prev.passwordErrorKey,
        password2ErrorKey: prev.password2ErrorKey,
      };

      if (name === "email") {
        nextState.error.email = this.validateEmail(value);
      }

      if (name === "password") {
        nextState.passwordErrorKey = "";
        if (value && !isPasswordStrong(value)) {
          nextState.error.password = true;
        }
        if (
          nextForm.password2 &&
          nextForm.password2 !== value
        ) {
          nextState.error.password2 = true;
          nextState.password2ErrorKey = "warning_password_similar";
        } else if (nextForm.password2) {
          nextState.error.password2 = false;
          nextState.password2ErrorKey = "";
        }
      }

      if (name === "password2") {
        nextState.password2ErrorKey = "";
        if (value && value !== nextForm.password) {
          nextState.error.password2 = true;
        }
      }

      return nextState;
    });
  };

  onChangeAcceptTos = () => {
    this.setState((prev) => ({
      accept_tos: !prev.accept_tos,
    }));
  };

  onClickRegister = async (e) => {
    e.preventDefault();

    if (!this.state.accept_tos) {
      alertify.alert(I18n.t("warning"), I18n.t("warning_tos"), () => {});
      return;
    }

    if (!this.state.form.country_id) {
      this.setState((prev) => ({
        error: { ...prev.error, country_id: true },
      }));
      return;
    }

    if (!this.state.form.email || this.validateEmail(this.state.form.email)) {
      this.setState((prev) => ({
        error: { ...prev.error, email: true },
      }));
      return;
    }

    const passwordErrorKey = this.getPasswordErrorKey(this.state.form.password);
    if (passwordErrorKey) {
      this.setState({
        error: { ...this.state.error, password: true },
        passwordErrorKey,
      });
      return;
    }

    if (!this.state.form.password2) {
      this.setState({
        error: { ...this.state.error, password2: true },
        password2ErrorKey: "warning_password_confirm",
      });
      return;
    }

    if (this.state.form.password2 !== this.state.form.password) {
      this.setState({
        error: { ...this.state.error, password2: true, password: true },
        password2ErrorKey: "warning_password_similar",
      });
      return;
    }

    try {
      const result = await this.props.RegisterUser(this.state.form);
      if (result.ok && result.pendingActivation) {
        this.props.history.replace("/register_successfull");
      } else if (result.ok) {
        this.props.history.replace("/home");
      } else if (result.error) {
        alertify.warning(I18n.t(result.error));
      }
    } catch (error) {
      console.log(error);
      alertify.warning(I18n.t("try_later"));
    }
  };

  render() {
    return (
      <div className="register-page">
        <div className="register-page__layout">
          <RegisterTips />
          <RegisterForm
            onChange={this.onChangeForm}
            form={this.state.form}
            error={this.state.error}
            passwordErrorKey={this.state.passwordErrorKey}
            password2ErrorKey={this.state.password2ErrorKey}
            accept_tos={this.state.accept_tos}
            onChangeAcceptTos={this.onChangeAcceptTos}
            onClickRegister={this.onClickRegister}
            submitting={this.props.loading}
            history={this.props.history}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    error_update: reducer.session.error,
    loading: reducer.session.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  RegisterUser: (params) => dispatch(actions.newItem({ params })),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Register));
